import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import List from '@/components/List'
import Detail from '@/components/Detail'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Index',
    component: Index
  }, {
    path: '/list',
    name: 'List',
    component: List
  }, {
    path: '/detail',
    name: 'Detail',
    component: Detail
  }]
})


// WEBPACK FOOTER //
// ./src/router/index.js